export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 py-14 md:py-20">
          <div>
            <h4 className="text-foreground-950 font-heading text-base mb-4">
              <a href="/category/mingxing-bagua" className="hover:text-primary-500 transition-colors">热门分类</a>
            </h4>
            <div className="w-8 h-px bg-accent-500/40 mb-4"></div>
            <ul className="space-y-2.5">
              <li><a href="/category/mingxing-bagua" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">明星八卦</a></li>
              <li><a href="/category/shipin-heiliao" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">视频黑料</a></li>
              <li><a href="/category/tuwen-shichui" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">图文实锤</a></li>
              <li><a href="/category/zhibo-chigua" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">直播吃瓜</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-950 font-heading text-base mb-4">
              <a href="/category/wanghong-fancheshijian" className="hover:text-primary-500 transition-colors">深度追踪</a>
            </h4>
            <div className="w-8 h-px bg-accent-500/40 mb-4"></div>
            <ul className="space-y-2.5">
              <li><a href="/category/yule-shendu" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">娱乐深度</a></li>
              <li><a href="/category/neiyu-bagua" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">内娱八卦</a></li>
              <li><a href="/category/jingdian-tafang" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">经典塌房</a></li>
              <li><a href="/category/wanghong-fancheshijian" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">网红翻车</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-950 font-heading text-base mb-4">
              <span>法律声明</span>
            </h4>
            <div className="w-8 h-px bg-accent-500/40 mb-4"></div>
            <ul className="space-y-2.5">
              <li><a href="/about" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">关于我们</a></li>
              <li><a href="/about" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">免责声明</a></li>
              <li><a href="/about" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">隐私政策</a></li>
              <li><a href="/about" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">用户协议</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-950 font-heading text-base mb-4">
              <span>合作联系</span>
            </h4>
            <div className="w-8 h-px bg-accent-500/40 mb-4"></div>
            <ul className="space-y-2.5">
              <li><a href="/about" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">爆料投稿</a></li>
              <li><a href="/about" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">商务合作</a></li>
              <li><a href="/about" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">内容申诉</a></li>
              <li><a href="/about" className="text-foreground-500 hover:text-foreground-950 text-sm transition-colors duration-200">加入我们</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 py-8 md:py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="text-foreground-950 font-heading text-2xl md:text-3xl">51</span>
            <span className="text-primary-500 font-heading text-2xl md:text-3xl">黑料</span>
          </div>
          <p className="text-foreground-400 text-xs md:text-sm text-center">
            &copy; 2024-2026 51黑料不打烊。本站内容均来自网友投稿，不代表本站立场。如有侵权请联系删除。
          </p>
          <div className="flex items-center gap-3">
            <a href="#" aria-label="微博" className="w-9 h-9 rounded-full bg-background-200 hover:bg-primary-500 flex items-center justify-center transition-colors duration-300" rel="nofollow">
              <i className="ri-weibo-line text-foreground-500 hover:text-background-50 text-sm transition-colors duration-300"></i>
            </a>
            <a href="#" aria-label="微信" className="w-9 h-9 rounded-full bg-background-200 hover:bg-primary-500 flex items-center justify-center transition-colors duration-300" rel="nofollow">
              <i className="ri-wechat-line text-foreground-500 hover:text-background-50 text-sm transition-colors duration-300"></i>
            </a>
            <a href="#" aria-label="B站" className="w-9 h-9 rounded-full bg-background-200 hover:bg-primary-500 flex items-center justify-center transition-colors duration-300" rel="nofollow">
              <i className="ri-bilibili-line text-foreground-500 hover:text-background-50 text-sm transition-colors duration-300"></i>
            </a>
            <a href="#" aria-label="抖音" className="w-9 h-9 rounded-full bg-background-200 hover:bg-primary-500 flex items-center justify-center transition-colors duration-300" rel="nofollow">
              <i className="ri-tiktok-line text-foreground-500 hover:text-background-50 text-sm transition-colors duration-300"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}